__turbopack_context__.v({
  "donate_search_row": "DonateSearchRow-module-scss-module__5egDqG__donate_search_row",
  "donate_search_row__button": "DonateSearchRow-module-scss-module__5egDqG__donate_search_row__button",
  "donate_search_row__content": "DonateSearchRow-module-scss-module__5egDqG__donate_search_row__content",
  "donate_search_row__description": "DonateSearchRow-module-scss-module__5egDqG__donate_search_row__description",
  "donate_search_row__image": "DonateSearchRow-module-scss-module__5egDqG__donate_search_row__image",
  "donate_search_row__logo": "DonateSearchRow-module-scss-module__5egDqG__donate_search_row__logo",
});
